const EmailObfuscate = () => {
    const emailLinks = document.querySelectorAll('.js-obfuscated-email');

    if (!emailLinks.length) {
        return;
    }

    emailLinks.forEach(emailLink => {
        if (emailLink.dataset.emailObfuscatedInit) {
            return;
        }

        emailLink.dataset.emailObfuscatedInit = 'true';

        emailLink.addEventListener('click', event => {
            const encodedEmail = emailLink.getAttribute('data-email');

            event.preventDefault();

            if (!encodedEmail) {
                return;
            }

            const email = atob(encodedEmail);
            const mailto = `mailto:${email}`;

            emailLink.setAttribute('href', mailto);
            window.location.href = mailto;
        });
    });
};

export default EmailObfuscate;
